import { render, staticRenderFns } from "./PasswordlessStep.vue?vue&type=template&id=f538e870&"
import script from "./PasswordlessStep.vue?vue&type=script&lang=ts&"
export * from "./PasswordlessStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports